<div
  class="ff"
  [class.ff--focused]="focused()"
  [class.ff--filled]="hasValue"
  [class.ff--error]="!!error || invalid"
  [class.ff--disabled]="disabled()"
  [class.ff--label-above]="labelPlacement === 'above'"
>
  @if (label && labelPlacement === "above") {
    <label [for]="id" class="ff__label ff__label--above">
      {{ label }}
      @if (required) {
        <span class="ff__req">*</span>
      }
    </label>
  }

  <div class="ff__control">
    @switch (type) {
      @case ("textarea") {
        <textarea
          [id]="id"
          class="ff__input ff__input--textarea"
          [rows]="rows"
          [attr.placeholder]="
            labelPlacement === 'floating' && label ? ' ' : placeholder
          "
          [autocomplete]="autocomplete"
          [disabled]="disabled()"
          [value]="value()"
          (input)="onInput($event)"
          (focus)="onFocus()"
          (blur)="onBlur()"
        ></textarea>
      }
      @case ("select") {
        <select
          [id]="id"
          class="ff__input ff__input--select"
          [disabled]="disabled()"
          [value]="value()"
          (change)="onInput($event)"
          (focus)="onFocus()"
          (blur)="onBlur()"
        >
          @if (placeholder) {
            <option value="" disabled hidden>{{ placeholder }}</option>
          }
          @for (opt of options; track opt.value) {
            <option [value]="opt.value">{{ opt.label }}</option>
          }
        </select>
      }
      @default {
        <input
          [id]="id"
          class="ff__input"
          [type]="inputType"
          [attr.placeholder]="
            labelPlacement === 'floating' && label ? ' ' : placeholder
          "
          [autocomplete]="autocomplete"
          [disabled]="disabled()"
          [value]="value()"
          (input)="onInput($event)"
          (focus)="onFocus()"
          (blur)="onBlur()"
        />
      }
    }

    @if (label && labelPlacement === "floating") {
      <label [for]="id" class="ff__label">
        {{ label }}
        @if (required) {
          <span class="ff__req">*</span>
        }
      </label>
    }

    @if (type === "password") {
      <button
        type="button"
        class="ff__toggle"
        [disabled]="disabled()"
        (click)="togglePassword()"
        tabindex="-1"
        [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
      >
        <i
          class="ic"
          [class.ic-eye]="!showPassword()"
          [class.ic-eye-slash]="showPassword()"
        ></i>
      </button>
    }
  </div>

  @if (error) {
    <small class="ff__error">{{ error }}</small>
  } @else if (hint) {
    <small class="ff__hint">{{ hint }}</small>
  }
</div>
